import React from 'react';

const MetricsCards = ({ activeTab, setActiveTab }) => {
  return (
    <>
      {/* Tab Buttons */}
      <nav className="reports-tabs" aria-label="Report sections">
        {['Overview', 'Orders', 'Items'].map((tab) => (
          <button
            key={tab}
            type="button"
            aria-current={activeTab === tab ? 'page' : undefined}
            onClick={() => setActiveTab(tab)}
            className={`px-4 py-2 font-medium rounded-t ${
              activeTab === tab
                ? 'bg-blue-500 text-white'
                : 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-200'
            }`}
          >
            {tab}
          </button>
        ))}
      </nav>
    </>
  );
};

export default MetricsCards;
